import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-order\"><defs><style type=\"text/css\"></style></defs><path d=\"M821.333333 85.333333A32 32 0 0 1 853.333333 117.333333V640H565.333333a32 32 0 0 0-31.850666 28.928L533.333333 672V938.666667H202.666667A32 32 0 0 1 170.666667 906.666667v-789.333334A32 32 0 0 1 202.666667 85.333333h618.666666z m12.736 618.666667l-196.138666 213.930667a64 64 0 0 1-40.576 20.394666L597.333333 725.333333l0.149334-2.496a21.333333 21.333333 0 0 1 18.688-18.688L618.666667 704h215.402666zM501.333333 533.333333h-149.333333a32 32 0 0 0 0 64h149.333333a32 32 0 0 0 0-64z m170.666667-149.333333h-320a32 32 0 0 0-3.072 63.850667L352 448h320a32 32 0 0 0 0-64z m0-149.333333h-320a32 32 0 0 0-3.072 63.850666L352 298.666667h320a32 32 0 0 0 0-64z\" p-id=\"1847\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/order.svg
// module id = yFCU
// module chunks = 7